import { Store } from '../../types'

export const contractProductsSelector = (store: Store) => store.entities.contractProducts
